var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolarBackspaceLinear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.142 20.2698C8.915 20.2698 7.801 20.2698 6.872 19.7688C5.942 19.2668 5.352 18.3488 4.171 16.5098L3.49 15.4498C2.497 13.9038 2 13.1298 2 12.2698C2 11.4098 2.497 10.6358 3.49 9.08978L4.17 8.02978C5.351 6.19178 5.941 5.27278 6.871 4.77078C7.801 4.26978 8.915 4.26978 11.142 4.26978H13.779C17.654 4.26978 19.592 4.26978 20.796 5.44178C22 6.61278 22 8.49878 22 12.2698C22 16.0408 22 17.9268 20.796 19.0978C19.592 20.2698 17.654 20.2698 13.78 20.2698H11.142Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.76978L10.5 14.7698M10.5 9.76978L15.5 14.7698",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarBackspaceLinear);
export default __webpack_public_path__ + "static/media/solar_backspace-linear.d77fbbdbc32140873bf33ca79b6f7b79.svg";
export { ForwardRef as ReactComponent };